import { createTypes } from 'redux-create-types';
import { fromType, } from 'kreighter';

const namespace = 'course';

export const courseActions = createTypes([
    'save',
    'remove',
    'addChapter',
    'removeChapter',
    'updateProgress',
    'updateParticipationRate',
    'updateBreadcrumb',
    'updateFinalScores',
    'addFinalScoresFactor',
    'removeFinalScoresFactor',
    'cleanAllScoresFactor',
    'setPeriods',
], namespace);

export const courseActionCreators = {
    save: fromType(courseActions.save, ['course']),
    remove: fromType(courseActions.remove, ['id']),
    addChapter: fromType(courseActions.addChapter, ['chapter', 'courseId']),
    removeChapter: fromType(courseActions.removeChapter, ['chapterId', 'courseId']),
    updateProgress: fromType(courseActions.updateProgress, ['courseId', 'lockedUnitsCount', 'seenUnitsCount', 'totalUnitsCount']),
    updateParticipationRate: fromType(courseActions.updateParticipationRate, ['courseId', 'participationRate']),
    updateBreadcrumb: fromType(courseActions.updateBreadcrumb, ['items']),
    updateFinalScores: fromType(courseActions.updateFinalScores, ['id', 'date', 'score']),
    addFinalScoresFactor: fromType(courseActions.addFinalScoresFactor, ['courseId', 'key', 'coefficient', 'totalScore', 'score']),
    cleanAllScoresFactor: fromType(courseActions.cleanAllScoresFactor, ['courseId']),
    removeFinalScoresFactor: fromType(courseActions.removeFinalScoresFactor, ['courseId', 'key']),
    setPeriods: fromType(courseActions.setPeriods, ['courseId', 'items']),
}
